// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-fab {
  align-items: center;
  display: inline-flex;
  flex: 1 1 auto;
  pointer-events: none;
  position: relative;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
}
:where(.vuetify-styles) .v-fab .v-btn {
  pointer-events: auto;
}
:where(.vuetify-styles) .v-fab .v-btn--variant-elevated {
  box-shadow: 0px 3px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 3px 4px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 8px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-fab--app, :where(.vuetify-styles) .v-fab--absolute {
  display: flex;
}
:where(.vuetify-styles) .v-fab--absolute {
  position: absolute;
  inset: 0;
}
:where(.vuetify-styles) .v-fab--start, :where(.vuetify-styles) .v-fab--left {
  justify-content: flex-start;
}
:where(.vuetify-styles) .v-fab--center {
  align-items: center;
  justify-content: center;
}
:where(.vuetify-styles) .v-fab--end, :where(.vuetify-styles) .v-fab--right {
  justify-content: flex-end;
}
:where(.vuetify-styles) .v-fab--bottom {
  align-items: flex-end;
}
:where(.vuetify-styles) .v-fab--top {
  align-items: flex-start;
}
:where(.vuetify-styles) .v-fab--extended .v-btn {
  border-radius: 9999px !important;
}

:where(.vuetify-styles) .v-fab__container {
  align-self: center;
  display: inline-flex;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-fab--app .v-fab__container {
  margin: 12px;
  position: fixed;
}
:where(.vuetify-styles) .v-fab--absolute .v-fab__container {
  position: absolute;
  z-index: 4;
}
:where(.vuetify-styles) .v-fab--offset.v-fab--top .v-fab__container {
  transform: translateY(-50%);
}
:where(.vuetify-styles) .v-fab--offset.v-fab--bottom .v-fab__container {
  transform: translateY(50%);
}
:where(.vuetify-styles) .v-fab--top .v-fab__container {
  top: 0;
}
:where(.vuetify-styles) .v-fab--bottom .v-fab__container {
  bottom: 0;
}
:where(.vuetify-styles) .v-fab--left .v-fab__container, :where(.vuetify-styles) .v-fab--start .v-fab__container {
  left: 0;
}
:where(.vuetify-styles) .v-fab--right .v-fab__container, :where(.vuetify-styles) .v-fab--end .v-fab__container {
  right: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VFab/VFab.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uOAAuO;AACzO;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV","sourcesContent":[".v-fab {\n  align-items: center;\n  display: inline-flex;\n  flex: 1 1 auto;\n  pointer-events: none;\n  position: relative;\n  transition-duration: 0.2s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  vertical-align: middle;\n}\n.v-fab .v-btn {\n  pointer-events: auto;\n}\n.v-fab .v-btn--variant-elevated {\n  box-shadow: 0px 3px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 3px 4px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 8px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-fab--app, .v-fab--absolute {\n  display: flex;\n}\n.v-fab--absolute {\n  position: absolute;\n  inset: 0;\n}\n.v-fab--start, .v-fab--left {\n  justify-content: flex-start;\n}\n.v-fab--center {\n  align-items: center;\n  justify-content: center;\n}\n.v-fab--end, .v-fab--right {\n  justify-content: flex-end;\n}\n.v-fab--bottom {\n  align-items: flex-end;\n}\n.v-fab--top {\n  align-items: flex-start;\n}\n.v-fab--extended .v-btn {\n  border-radius: 9999px !important;\n}\n\n.v-fab__container {\n  align-self: center;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.v-fab--app .v-fab__container {\n  margin: 12px;\n  position: fixed;\n}\n.v-fab--absolute .v-fab__container {\n  position: absolute;\n  z-index: 4;\n}\n.v-fab--offset.v-fab--top .v-fab__container {\n  transform: translateY(-50%);\n}\n.v-fab--offset.v-fab--bottom .v-fab__container {\n  transform: translateY(50%);\n}\n.v-fab--top .v-fab__container {\n  top: 0;\n}\n.v-fab--bottom .v-fab__container {\n  bottom: 0;\n}\n.v-fab--left .v-fab__container, .v-fab--start .v-fab__container {\n  left: 0;\n}\n.v-fab--right .v-fab__container, .v-fab--end .v-fab__container {\n  right: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
